import { defaultTransitionClass, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const tabItemClass = style([
  defaultTransitionClass,
  {
    position: 'relative',
    height: 32,
    width: 24,
  },
]);

export const underlineBorderClass = style([
  defaultTransitionClass,
  {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: themeVars.colors.neutrals.grey50,
    height: 6,
  },
]);
